import request from '@/router/axios';

export const getList = (current, size, params) => {
  return request({
    url: '/api/blade-contract/contract/list',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/api/blade-contract/contract/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/api/blade-contract/contract/remove',
    method: 'post',
    params: {
      ids,
    }
  })
}

export const add = (row) => {
  return request({
    url: '/api/blade-contract/contract/save',
    method: 'post',
    data: {
      // processDefinitionId: 'Leave:3:9c697765-add5-11ed-989d-005056c00008',
      // processDefinitionId: 'Contract:6:96d681fb-b809-11ed-b2e1-005056c00008',
      ...row
    }
  })
}

export const update = (row) => {
  return request({
    url: '/api/blade-contract/contract/update',
    method: 'post',
    data: row
  })
}

export const toVoid = (ids) => {
  return request({
    url: '/api/blade-contract/contract/toVoid',
    method: 'post',
    params: {
      ids,
    }
  })
}
